import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { ModalService } from 'src/app/shared/service/modal.service';
import { isEmptyObj } from '../class/utilityHelper';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard {
  constructor(private auth: AuthService) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.auth.loginStatus()) {
      this.auth.redirectToLogin();
      return false;
    } else {
      return true;
    }
  }
}
@Injectable({
  providedIn: 'root'
})
export class LogoutGuard {
  constructor(private auth: AuthService) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.loginStatus()) {
      this.auth.redirectToDashboard();
      return false;
    } else {
      return true;
    }
  }
}


@Injectable({
  providedIn: 'root',
})
export class StrictNoAuthhGuard {
  constructor(
    private authenticationService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authenticationService.loginStatus()) {
      // logged in so return true
      this.authenticationService.redirectToDashboard();
      return false;
    } else {
      return true;
    }
    // not logged in so redirect to login page with the return url
  }
}

@Injectable({
  providedIn: 'root'
})
export class PassCodeGuard {
  constructor(private auth: AuthService, private modalServe: ModalService) { }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree> {
    const setting = this.auth.currentSettingValue;
    // if (!isEmptyObj(setting) && (setting.master_passcode !== '' && setting.master_passcode != null)) {
      //check 
      if (isEmptyObj(!setting)) {
        //check 
        if(!setting.master_passcode){
          return true;
        }
      return await this.modalServe.openConfirmDialog({
        title: 'Verify User', message: '', isFormField: true,
        formField: [{ colName: 'passcode', title: 'Passcode', validator: [{ name: 'required' }], type: 'PASSWORD' }]
      }).then((resultConfirm: any) => {
        console.log('result ,', resultConfirm, resultConfirm.passcode == setting.master_passcode)
        return resultConfirm.passcode == setting.master_passcode
      })
    }
    return false
  }
}